<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"Assign" | translate}} to {{dialogData}} </h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content  mt-4 px-2">
        <form action="" [formGroup]="assignForm">
            <div class="overflow-cont">

                <label for="" class="me-3 mt-3 pt-lg-2">Select {{dialogData}} </label>
                <div *ngIf="dialogData == 'manager'">
                    <mat-select class="form-control select-class" placeholder="Select manager" formControlName="ma_i">
                        <!-- Search Input -->
                        <input class="form-control form-control-i mt-0 ms-3 me-3 m-auto mb-2" matInput
                            placeholder="Search..." [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="managerItem.searchText" (click)="$event.stopPropagation()" />

                        <!-- Filtered List -->
                        <mat-option *ngFor="let manager of getFilteredList(managerItem)" [value]="manager.ma_i">
                            {{manager.f_n}} {{manager.l_n}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assignForm.get('ma_i')?.hasError('required') && assignForm.get('ma_i')?.touched">
                        Manager selection is required
                    </mat-error>
                </div>

                <div *ngIf="dialogData == 'employee'">
                    <mat-select class="form-control select-class" placeholder="Select employee" formControlName="em_i">
                        <!-- Search Input -->

                        <input class="form-control form-control-i mt-0 ms-3 me-3 m-auto mb-2" matInput
                            placeholder="Search..." [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="employeeItem.searchText" (click)="$event.stopPropagation()" />
                        <!-- Filtered List -->
                        <mat-option *ngFor="let emp of getFilteredList(employeeItem)" [value]="emp.em_i">
                            {{emp.f_n}} {{emp.l_n}}
                        </mat-option>

                    </mat-select>
                    <mat-error *ngIf="assignForm.get('em_i')?.hasError('required') && assignForm.get('em_i')?.touched">
                        Employee selection is required
                    </mat-error>
                </div>

                <mat-checkbox name="agree" class="mt-4 c-s ms-2" formControlName="all_user"
                    (change)="onAllUserChange()">
                    <div class="text-wrap">Assign all user to {{dialogData}}</div>
                </mat-checkbox>

                <div class="ms-3" *ngIf="assignForm.value.all_user!=true">
                    <label for="" class="me-3  pt-lg-2">Select User </label>
                    <div class="list ">

                        <!-- <div *ngIf="dialogData != 'manager'">
                            <mat-select class="form-control select-class" placeholder="Select manager" [multiple]="true"
                                formControlName="ma_i">
                                
                                <input class="form-control mt-0 m-auto mb-2" matInput placeholder="Search..."
                                    (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" />
                              
                                <mat-option *ngFor="let managers of managerArr" [value]="managers.ma_i">
                                    {{managers.f_n}}{{managers.l_n}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="assignForm.get('ma_i')?.hasError('required') && assignForm.get('ma_i')?.touched">
                                Manager selection is required
                            </mat-error>
                        </div>

                        <div *ngIf="dialogData != 'employee'">
                            <mat-select class="form-control select-class" placeholder="Select employee"
                                [multiple]="true" formControlName="em_i">

                                <input class="form-control mt-0 m-auto mb-2" matInput placeholder="Search..."
                                    (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" />

                             
                                <mat-option *ngFor="let emp of empArr" [value]="emp.em_i">
                                    {{emp.f_n}}{{emp.l_n}}
                                </mat-option>

                            </mat-select>
                            <mat-error
                                *ngIf="assignForm.get('em_i')?.hasError('required') && assignForm.get('em_i')?.touched">
                                Employee selection is required
                            </mat-error>
                        </div> -->


                        <!-- Manager -->
                        <div *ngIf="dialogData != 'manager'">
                            <mat-select class="form-control select-class" placeholder="Select manager" [multiple]="true"
                                formControlName="ma_i">

                                <!-- Search Input -->
                                <input class="form-control form-control-i mt-0 ms-3 me-3 m-auto mb-2" matInput
                                    placeholder="Search..." [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="managerItem.searchText" (click)="$event.stopPropagation()" />

                                <!-- Filtered List -->
                                <mat-option *ngFor="let manager of getFilteredList(managerItem)" [value]="manager.ma_i">
                                    {{manager.f_n}} {{manager.l_n}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="assignForm.get('ma_i')?.hasError('required') && assignForm.get('ma_i')?.touched">
                                Manager selection is required
                            </mat-error>
                        </div>

                        <!-- Employee -->
                        <div *ngIf="dialogData != 'employee'">
                            <mat-select class="form-control select-class" placeholder="Select employee"
                                [multiple]="true" formControlName="em_i">

                                <!-- Search Input -->

                                <input class="form-control form-control-i mt-0 ms-3 me-3 m-auto mb-2" matInput
                                    placeholder="Search..." [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="employeeItem.searchText" (click)="$event.stopPropagation()" />


                                <!-- Filtered List -->
                                <mat-option *ngFor="let emp of getFilteredList(employeeItem)" [value]="emp.em_i">
                                    {{emp.f_n}} {{emp.l_n}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="assignForm.get('em_i')?.hasError('required') && assignForm.get('em_i')?.touched">
                                Employee selection is required
                            </mat-error>
                        </div>


                    </div>

                </div>



            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto mt-xl-2">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                (click)="onSubmit()">{{
                "Save" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>